import { useEffect } from 'react';
import { useDialogStore } from '@/stores/dialog-store';

export function GlobalDialogProvider() {
  const { isOpen, config, close } = useDialogStore();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen || !config) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/30 backdrop-blur-[2px] animate-in fade-in duration-200">
      <div 
        className="bg-white/95 backdrop-blur-xl w-[270px] rounded-[14px] shadow-2xl flex flex-col items-center animate-in zoom-in-95 duration-200"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-5 flex flex-col items-center text-center">
          {config.title && (
            <h3 className="text-[17px] font-semibold text-black tracking-tight leading-snug mb-1">
              {config.title}
            </h3>
          )}
          <p className="text-[13px] text-black/80 leading-tight">
            {config.message}
          </p>
        </div>

        <div className={`w-full flex ${config.type === 'confirm' ? 'flex-row' : 'flex-col'} border-t border-black/10`}>
          {config.type === 'confirm' && (
            <button
              onClick={() => close(false)}
              className="flex-1 py-3 text-[17px] text-ios-blue border-r border-black/10 hover:bg-black/5 active:bg-black/10 transition-colors focus:outline-none"
            >
              {config.cancelText || 'Cancelar'}
            </button>
          )}
          <button
            onClick={() => close(true)}
            className={`flex-1 py-3 text-[17px] font-semibold hover:bg-black/5 active:bg-black/10 transition-colors focus:outline-none ${
              config.destructive ? 'text-ios-red' : 'text-ios-blue'
            } ${config.type === 'alert' ? 'rounded-b-[14px]' : ''}`}
          >
            {config.confirmText || 'OK'}
          </button>
        </div>
      </div>
    </div>
  );
}
